import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';

const MIN_PAGINATION_ITEMS = 20;

const List = (props) => {
  const { items, columns } = props;

  if (!items || !items.length) {
    return (
      <div>
        No reports for selected dates
      </div>
    );
  }

  return (
    <div className="s-v2">
      <ReactTable
        data={items}
        showPagination={items.length > MIN_PAGINATION_ITEMS}
        minRows={0}
        resizable={false}
        className="c-inventory-report-table ReactTable ReactTable--row-spacing-only c-table-with-sticky-header c-table-new c-table--small c-no-hover"
        columns={columns}
      />
    </div>
  );
};

List.propTypes = {
  items: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
};

export default List;
